import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';

export const QuestionCard = ({
    title,
    text,
    questions = 1,
    departureAirport,
    arrivalAirport,
    departureRating,
    arrivalRating,
    setDeparture,
    setArrival,
    customOptions = false,
    airline
}) => {
    return (
        <Card className="mb-3 shadow-sm">
            <Card.Body>
                <Card.Title className="fw-bold">{title}</Card.Title>
                <Card.Text>{text}</Card.Text>

                {/* Departure */}
                {(departureAirport || airline) && (
                    <div className="mb-3">
                        <div className="text-primary fw-medium">{departureAirport}</div>
                        {customOptions ? (
                            <CustomOptions
                                selectedOption={departureRating}
                                onChange={setDeparture}
                                optionsName={"departure-waiting-time"}
                            />
                        ) : (
                            <StarRating
                                rating={departureRating}
                                setRating={setDeparture}
                            />
                        )}
                    </div>
                )}

                {/* Arrival */}
                {questions === 2 && arrivalAirport && (
                    <div>
                        <div className="text-primary fw-medium">{arrivalAirport}</div>
                        {customOptions ? (
                            <CustomOptions
                                selectedOption={arrivalRating}
                                onChange={setArrival}
                                optionsName={"arrival-waiting-time"}
                            />
                        ) : (
                            <StarRating
                                rating={arrivalRating}
                                setRating={setArrival}
                            />
                        )}
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export const CustomOptions = ({ selectedOption, onChange, optionsName }) => {
    const options = ["less than 15mins", "15 - 30 mins", "more than 30 mins"];
    return (
        <>
            {options.map((option, idx) => (
                <Form.Check
                    key={idx}
                    type="radio"
                    name={optionsName}
                    label={option}
                    checked={selectedOption === option}
                    onChange={() => onChange(option)}
                    className="mb-2"
                />
            ))}
        </>
    );
};

export const StarRating = ({ rating, setRating }) => {
    return (
        <div>
            {[...Array(5)].map((_, i) => (
                <FaStar
                    key={i}
                    onClick={() => setRating(i + 1)}
                    style={{ cursor: 'pointer', marginRight: 5 }}
                    color={i < rating ? '#007bff' : '#ccc'}
                />
            ))}
        </div>
    );
};

export const CommentCard = ({
    text,
    departureAirport,
    arrivalAirport,
    setCommentDeparture,
    setCommentArrival,
    airline
}) => {
    return (
        <Card className="mb-3 shadow-sm">
            <Card.Body>
                <Card.Title className="fw-bold">Comments</Card.Title>
                <Card.Text>{text}</Card.Text>

                {(departureAirport || airline) && (
                    <>
                        <div className="text-primary mb-1">{departureAirport}</div>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Comments"
                            onChange={(e) => setCommentDeparture(e.target.value)}
                            className="mb-3"
                        />
                    </>
                )}

                {arrivalAirport && (
                    <>
                        <div className="text-primary mb-1">{arrivalAirport}</div>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Comments"
                            onChange={(e) => setCommentArrival(e.target.value)}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};